import { render, staticRenderFns } from "./ReserveSameAppointmentFailed.vue?vue&type=template&id=9e319354"
import script from "./ReserveSameAppointmentFailed.vue?vue&type=script&lang=js"
export * from "./ReserveSameAppointmentFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports